import SplashScreen from '@/components/splash-screen/splash-screen';
import { KEY_REF_CODE } from '@/hooks/useRefCode';
import { useAuth } from '@/store/auth';
import { ReactNode, useEffect } from 'react';

import { useShallow } from 'zustand/shallow';

export function AuthProvider({ children }: { children: ReactNode }) {
    const [address] = useAuth(useShallow((state) => [state.address]));

    useEffect(() => {
        let refCode = null;
        const pathname = location.pathname;

        if (
            (pathname.length > 0 && pathname.startsWith('/ref')) ||
            pathname.startsWith('//ref')
        ) {
            const temp = pathname.split('/');
            refCode = temp[temp.length - 1];
            localStorage.setItem(KEY_REF_CODE, refCode);
        }
    }, []);

    if (!address) {
        return <SplashScreen />;
    }

    return children;
}
